module.exports = __webpack_public_path__ + "js/chunk-29fd4fc0.e6ada562.worker.js"